(function($) {
  "use strict";

  jQuery(document).ready(function(){



    /*-------------------------------------------
  02. wow js active
--------------------------------------------- */

    new WOW().init();

    
    
    /*--------------------------
  05. ScrollUp
---------------------------- */
    $.scrollUp({
      scrollText: '<i class="zmdi zmdi-chevron-up"></i>',
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'fade'
    });



    /*---------------------------
  06. Tooltip
------------------------------*/    
    $('[data-toggle="tooltip"]').tooltip({
      animated: 'fade',
      placement: 'top',
      container: 'body'
    });



    /*-----------------------------------
  07. ScrollReveal Js Init
-------------------------------------- */

    window.sr = ScrollReveal({ duration: 800 , reset: true });
    sr.reveal('.foo');
    sr.reveal('.bar');



    /*-------------------------------------------------------
  08. Fixed Footer bottom script ( Newsletter )
--------------------------------------------------------*/

    var $newsletter_height = $(".htc__foooter__area");
    $('.fixed__footer').css({'margin-bottom': $newsletter_height.height() + 'px'});




    /*------------------------------------    
  09. Search Bar
--------------------------------------*/ 

    $( '.search__open' ).on( 'click', function () {
      $( 'body' ).toggleClass( 'search__box__show__hide' );
      return false;
    });

    $( '.search__close__btn .search__close__btn_icon' ).on( 'click', function () {
      $( 'body' ).toggleClass( 'search__box__show__hide' );
      return false;
    });




    /*------------------------------------    
  10. Toogle Menu
--------------------------------------*/

    $('.toggle__menu').on('click', function() {
      $('.offsetmenu').addClass('offsetmenu__on');
      $('.body__overlay').addClass('is-visible');

    });

    $('.offsetmenu__close__btn').on('click', function() {
      $('.offsetmenu').removeClass('offsetmenu__on');
      $('.body__overlay').removeClass('is-visible');
    });

    /*------------------------------------    
  11. Shopping Cart Area
--------------------------------------*/

    $('.cart__menu_2').on('click', function() {
      $('.shopping__cart').addClass('shopping__cart__on');
      $('.body__overlay').addClass('is-visible');

    });

    $('.offsetmenu__close__btn').on('click', function() {
      $('.shopping__cart').removeClass('shopping__cart__on');
      $('.body__overlay').removeClass('is-visible');
    });


    $('.cart__menu').on('click', function() {
      setTimeout(function () {
        $('.shopping__cart').addClass('shopping__cart__on');
        $('.body__overlay').addClass('is-visible');
      },1400);
      $(this).addClass('loading add-item');
      setTimeout(function () {
        $('.cart__menu').removeClass('loading');
      },800);
      setTimeout(function () {
        $('.cart__menu').removeClass("add-item");
      },1500);

    });


    /*------------------------------------    
  12. Filter Area
--------------------------------------*/

    $('.filter__menu').on('click', function() {
      $('.filter__wrap').addClass('filter__menu__on');
      $('.body__overlay').addClass('is-visible');

    });

    $('.filter__menu__close__btn').on('click', function() {
      $('.filter__wrap').removeClass('filter__menu__on');
      $('.body__overlay').removeClass('is-visible');
    });



    /*------------------------------------    
  13. User Menu
--------------------------------------*/

    $('.user__menu').on('click', function() {
      $('.user__meta').addClass('user__meta__on');
      $('.body__overlay').addClass('is-visible');

    });

    $('.offsetmenu__close__btn').on('click', function() {
      $('.user__meta').removeClass('user__meta__on');
      $('.body__overlay').removeClass('is-visible');
    });



    /*------------------------------------    
  14. Overlay Close
--------------------------------------*/
    $('.body__overlay').on('click', function() {
      $(this).removeClass('is-visible');
      $('.offsetmenu').removeClass('offsetmenu__on');
      $('.shopping__cart').removeClass('shopping__cart__on');
      $('.filter__wrap').removeClass('filter__menu__on');
      $('.user__meta').removeClass('user__meta__on');
    });



    /*-----------------------------------------------
  15. Home Slider
-------------------------------------------------*/

    if ($('.slider__activation__wrap').length) {
      $('.slider__activation__wrap').owlCarousel({
        loop: true,
        margin:0,
        nav:true,
        autoplay: true,
        navText: [ '<i class="zmdi zmdi-chevron-left"></i>', '<i class="zmdi zmdi-chevron-right"></i>' ],
        autoplayTimeout: 555510000,
        items:1,
        dots: true,
        lazyLoad: true,
        autoplayHoverPause: true,
        dotsData: true,
        responsive:{
          0:{
            items:1
          },
          600:{
            items:1
          },
          800:{
            items:1
          },
          1024:{
            items:1
          },
          1200:{
            items:1
          },
          1400:{
            items:1
          },
          1920:{
            items:1
          }
        }
      });
    }


    /*-----------------------------------------------
  17. Testimonial Wrap
-------------------------------------------------*/


    $('.testimonial__wrap').owlCarousel({
      loop: true,
      margin:0,
      nav:false,
      autoplay: false,
      navText: false,
      autoplayTimeout: 10000,
      items:1,
      dots: false,
      lazyLoad: true,
      responsive:{
        0:{
          items:1
        },
        600:{
          items:1
        },
        800:{
          items:1
        },
        1024:{
          items:1
        },
        1200:{
          items:1
        },
        1400:{
          items:1
        },
        1920:{
          items:1
        }
      }
    });




    /*--------------------------------
  18. Magnific Popup
----------------------------------*/

    $('.video-popup').magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      zoom: {
        enabled: true,
      }
    });

    $('.image-popup').magnificPopup({
      type: 'image',
      mainClass: 'mfp-fade',
      removalDelay: 100,
      gallery:{
        enabled:true, 
      }
    });





    /*-------------------------------
  19. Price Slider Active
--------------------------------*/
    $("#slider-range").slider({
      range: true,
      min: 10,
      max: 500,
      values: [110, 400],
      slide: function(event, ui) {
        $("#amount").val("$" + ui.values[0] + " - $" + ui.values[1]);
      }
    });
    $("#amount").val("$" + $("#slider-range").slider("values", 0) +
                     " - $" + $("#slider-range").slider("values", 1));




    /*-------------------------------
  20.  Plus Minus Button 
--------------------------------*/


    $(".cart-plus-minus").append('<div class="dec qtybutton">-</i></div><div class="inc qtybutton">+</div>');

    $(".qtybutton").on("click", function () {
      var $button = $(this);
      var oldValue = $button.parent().find("input").val();
      if ($button.text() == "+") {
        var newVal = parseFloat(oldValue) + 1;
      } else {
        // Don't allow decrementing below zero
        if (oldValue > 1) {
          var newVal = parseFloat(oldValue) - 1;
        } else {
          newVal = 1;
        }
      }
      $button.parent().find("input").val(newVal);
    });


    /*--------------------------
  21. jQuery scroll Nav
---------------------------- */
    $('.onepage--menu').onePageNav({
      scrollOffset: 0
    }); 		



    /* Mega Menu */	
    $('.megamenu-li').parent('ul').addClass('mega_dropdown');
    $('.mega_dropdown').parent('li').addClass('mega-menu-drop');	
    

    /* Match Heigh */  
    $(function() {
      $('.product__list .tab-pane > div').matchHeight();
    });  
    $(function() {
      $('.best__product__list > div').matchHeight();
    }); 
    $(function() {
      $('.blog__wrap.latest-blog > div').matchHeight();
    });
    $(function() {
      $('.blog__wrap > .row > div').matchHeight();
    });
    $(function() {
      $('.shop__page .product__list > div').matchHeight();
    });
    $(function() {
      $('.portfolio-style > .row > div').matchHeight();
    });
	$(function() {
      $('.footer__container > div').matchHeight();
    });

    
    
    
    /* Remove Attr */
    $('.offsetmenu__close__btn a').removeAttr('href');
    $('.filter__box a, .filter__menu__close__btn a').removeAttr('href'); 


    /* Ajax Wishlist */
    $(".action--wishlist").on('click', function(){
      $(this).addClass("loading-wishlist add-wishlist");
      setTimeout(function () {
        $(".action--wishlist").removeClass("loading-wishlist");
      },1000);
      setTimeout(function () {
        $(".add-wishlist").removeClass("add-wishlist");
      },1500);

    });

    /*---------------------
    countdown
  --------------------- */
    $('[data-countdown]').each(function() {
      var $this = $(this), finalDate = $(this).data('countdown');
      $this.countdown(finalDate, function(event) {
        $this.html(event.strftime('<span class="cdown day">%-D <p>Days</p></span> <span class="cdown hour">%-H <p>Hour</p></span> <span class="cdown minutes">%M <p>Min</p></span class="cdown second"> <span>%S <p>Sec</p></span>'));
      });
    }); 



  });

})(jQuery);



